import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { exportCampaignEntryPoints, fetchCampaignEntryPoints } from '@/services/ab-testing';
import { ABComparisonView } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/ab-comparison-view';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { ExportCSVButton } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/-features/export-csv-button';
export const Route = createFileRoute('/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/smart-links/')({
    component: CampaignSmartLinksAB,
});
function CampaignSmartLinksAB() {
    const { publicId } = Route.useParams();
    const { workspace } = useAuthenticationState();
    const { from, to, excludeDevices, excludeBrowsers } = Route.useSearch();
    const [fromDate, toDate] = React.useMemo(() => [new Date(from), new Date(to)], [from, to]);
    const q = useQuery({
        queryKey: ['ab', 'smart-links', 'campaign', publicId, fromDate, toDate, excludeDevices, excludeBrowsers],
        queryFn: () => fetchCampaignEntryPoints({
            publicId,
            from: fromDate,
            to: toDate,
            excludeDevices,
            excludeBrowsers,
        }),
    });
    if (!workspace)
        return null;
    return (<ABComparisonView title="Smart Links (Campaign)" description="Compare Smart Links across the whole campaign." heroLabel="Smart Link scans" comparison={q.data} loading={q.isPending} error={q.isError} itemName="Smart Link" actions={<ExportCSVButton filename={`adora-ab-smart-links-${publicId}-${format(new Date(), 'yyyy-MM-dd')}.csv`} workspace={workspace} request={() => exportCampaignEntryPoints({
                publicId,
                from: fromDate,
                to: toDate,
                excludeDevices,
                excludeBrowsers,
                fileFormat: 'csv',
            })}/>}/>);
}
